import React, {useState, useEffect, useCallback} from 'react';
import {useDispatch, useSelector} from 'react-redux';
// import t from "babel-plugin-yate/macro";

import {getTransaction, patchTransaction} from '../store/transaction';
import {addModal} from '../store/app';

import FooterOnline from '../components/FooterOnline';
import RequestNav from '../components/RequestNav';
import logo from '../assets/credex-logo-1.svg';
import TransactionStep1 from './Step1';
import TransactionStep2 from './Step2';
import TransactionStep3 from './Step3';
import ModalInfo from '../containers/ModalInfo';
import ModalInstantPayment from '../online/ModalInstantPayment';
import t from 'babel-plugin-yate/macro';

const instantPaymentModalId = 'instant_payment';
const infoModalId = 'info';
let tick = null;

function OnlineTransaction(props) {
  const {uuid} = props.match.params;
  const dispatch = useDispatch();
  const transaction = useSelector(state => state.transaction);
  const [currentStep, setCurrentStep] = useState();
  const [isApplicationLoading, setIsApplicationLoading] = useState(true);
  const [transactionErrorMessage, setTransactionErrorMessage] = useState();

  const handlerTransaction = useCallback(async () => {
    const transactionResponse = await dispatch(getTransaction(uuid));

    if (!transactionResponse?.data?.uuid) {
      setTransactionErrorMessage(transactionResponse.data);
    }

    setIsApplicationLoading(false);
  }, [dispatch, uuid]);

  const submitData = useCallback(
    async (values, isPatchSkipped) => {
      /**
       * 'isPatchSkipped' is sent as second argument in step three, as soon as the upload succeeded,
       * in order to have the latest value for the field 'checklist.income_uploaded'
       * */
      if (isPatchSkipped === true) {
        handlerTransaction();
        return;
      }

      const patchRes = await dispatch(patchTransaction(uuid, values));

      if (patchRes.status === 'success') {
        handlerTransaction();
      }
    },
    [dispatch, uuid, handlerTransaction],
  );

  const instantPaymentRedirect = useCallback(() => {
    if (transaction.payment === 'card') {
      return dispatch(addModal(instantPaymentModalId));
    }

    dispatch(addModal(infoModalId));
  }, [dispatch, transaction.payment]);

  useEffect(() => {
    handlerTransaction();
  }, [handlerTransaction]);

  useEffect(() => {
    if (transactionErrorMessage) {
      dispatch(addModal(infoModalId));
    }
  }, [dispatch, transactionErrorMessage]);

  useEffect(() => {
    if (transaction.in_progress) {
      dispatch(addModal(infoModalId));
      setCurrentStep();
      return;
    }

    switch (transaction.status) {
      case 'new':
        setCurrentStep(1);
        break;
      case 'approved':
        setCurrentStep(2);
        break;
      case 'awaiting_otp':
        setCurrentStep(3);
        break;
      case 'signed':
        instantPaymentRedirect();
        break;
      case 'done':
      case 'rejected':
      case 'cancelled':
      case 'expired':
        dispatch(addModal(infoModalId));
        break;
      default:
        setCurrentStep();
    }
  }, [
    dispatch,
    instantPaymentRedirect,
    transaction.in_progress,
    transaction.status,
  ]);

  useEffect(() => {
    clearInterval(tick);

    const delay =
      transaction.in_progress ||
      (['signed'].includes(transaction.status) &&
        transaction.payment === 'card')
        ? 10000
        : null;

    if (!delay) {
      return;
    }

    tick = setInterval(() => handlerTransaction(), delay);

    return () => clearInterval(tick);
  }, [
    transaction.status,
    uuid,
    transaction.in_progress,
    transaction.payment,
    handlerTransaction,
  ]);

  return isApplicationLoading ? (
    <div className="flex items-center justify-center relative h-screen text-20">
      <div className="spinner" />
    </div>
  ) : (
    <>
      <div className="pt-4">
        <img
          className="mx-auto"
          src={logo}
          alt="Credex logo"
          width="141"
          height="40"
        />
      </div>

      <div className="mx-auto">
        <RequestNav currentStep={currentStep} lendingTypeId={1001} />

        <div style={{minHeight: 'calc(100vh - 287px)'}}>
          {(['signed', 'done', 'rejected', 'cancelled', 'expired'].includes(
            transaction.status,
          ) ||
            transaction.in_progress ||
            transactionErrorMessage) && (
            <ModalInfo
              id={infoModalId}
              data={transaction}
              timeStamp={transaction.time_stamp ?? new Date()}
              appType="transaction"
              transactionErrorMessage={transactionErrorMessage}
            />
          )}

          {['signed'].includes(transaction.status) && (
            <ModalInstantPayment
              id={instantPaymentModalId}
              header={t`Bine ai venit! Credex – te ajuta sa primesti banii instant!`}
              data={transaction}
              uuid={uuid}
              appType="transaction"
            />
          )}

          {!transaction.in_progress && (
            <>
              {transaction.status === 'new' && (
                <TransactionStep1
                  data={transaction}
                  uuid={uuid}
                  patchHandler={submitData}
                />
              )}

              {transaction.status === 'approved' && (
                <TransactionStep2
                  data={transaction}
                  uuid={uuid}
                  status={transaction.status}
                  patchHandler={submitData}
                />
              )}

              {transaction.status === 'awaiting_otp' && (
                <TransactionStep3
                  data={transaction}
                  uuid={uuid}
                  status={transaction.status}
                  patchHandler={submitData}
                />
              )}
            </>
          )}
        </div>

        {
          /**
           * only when the transaction's data is fully retrieved
           * render the content, to avoid the color flickering
           * */
          Boolean(transaction.status) && (
            <FooterOnline orderOrigin={transaction.location_id} />
          )
        }
      </div>
    </>
  );
}

export default OnlineTransaction;
